import * as images from './images';

export const UserTypes = {
	ADMIN: 'ADMIN',
	AARIN: 'AARIN',
	WENDY: 'WENDY',
	RIDER: 'RIDER',
};

export const UserRoles = {
	ADMIN: 'ADMIN',
	REGIONAL_MANAGAER: 'REGIONAL_MANAGAER',
	AREA_MANAGER: 'AREA_MANAGER',
	STORE_MANAGER: 'STORE_MANAGER',
	CASHIER: 'CASHIER',
	OPERATIONS: 'OPERATIONS',
	FINANCE: 'FINANCE',
	TOMATI: 'TOMATI',
	SUPPORT: 'SUPPORT',
	SUPER: 'SUPER',
};

export const PromotionTypes = [
	{ code: 'CASHBACK', label: 'Cashback' },
	{ code: 'FLAT_OFF_ALL', label: 'Flat Discount Off All Orders' },
	{ code: 'FLAT_OFF_ITEM', label: 'Flat Discount Off Item(s)' },
	{ code: 'PERCENTAGE_OFF_ALL', label: 'Percentage Off All Orders' },
	{ code: 'PERCENTAGE_OFF_ITEM', label: 'Percentage Off Item(s)' },
];

export const PaymentOptions = [
	{ code: 'PAYSTACK', label: 'Bank Transfer / Visa / MasterCard' },
	{ code: 'WALLET', label: 'Wallet' },
	// { code: 'delivery', label: 'Pay on delivery' },
];

export const VoucherTypes = [
	{ code: 'BOGOF', label: 'Buy-One-Get-One-Free' },
	{ code: 'FLAT_OFF_ALL', label: 'Flat Discount' },
	{ code: 'PERCENTAGE_OFF_ALL', label: 'Percentage' },
];

export const PaymentStatusLabels = {
	PENDING: 'Pending',
	COMPLETED: 'Paid',
	FAILED: 'Failed',
};

export const orderStatusMap = {
	NEW: 'New',
	ACCEPTED: 'Accepted',
	PREPARING: 'Preparing',
	READY: 'Ready',
	DELIVERY: 'In Transit',
	COMPLETED: 'Completed',
	CANCELLED: 'Cancelled',
	ARRIVED: 'Rider Arrived',
	RIDER_PENDING: 'Pending Rider',
	RIDER_UNAVAILABLE: 'Rider Unavailable',
	PAYMENT: 'Pending Payment',
};

export const OrdersOrigins = {
	REPDASH: 'REPDASH',
	GLOVO: 'GLOVO',
	CHOWDECK: 'CHOWDECK',
};

export const DeliveryChannels = {
	REPDASH: 'REPDASH',
	GLOVO: 'GLOVO',
	CHOWDECK: 'CHOWDECK',
	GOKADA: 'GOKADA',
};

export const orderOrigins = [
	{ code: OrdersOrigins.REPDASH, label: 'RepDash' },
	{ code: OrdersOrigins.GLOVO, label: 'Glovo' },
	{ code: OrdersOrigins.CHOWDECK, label: 'Chowdeck' },
];

export const deliveryChannels = [
	{ code: DeliveryChannels.REPDASH, label: 'RepDash' },
	{ code: DeliveryChannels.GLOVO, label: 'Glovo' },
	{ code: DeliveryChannels.CHOWDECK, label: 'Chowdeck' },
	{ code: DeliveryChannels.GOKADA, label: 'Gokada' },
];

export const Providers = [
	{
		code: OrdersOrigins.GLOVO,
		label: 'Glovo',
		shortLabel: 'GV',
		image: images.GlovoIcon,
	},
	{
		code: OrdersOrigins.REPDASH,
		label: 'RepDash',
		shortLabel: 'CR',
		image: images.RepdashIcon,
	},
	{
		code: OrdersOrigins.CHOWDECK,
		label: 'ChowDeck',
		shortLabel: 'CD',
		image: images.ChowdeckIcon,
	},
	{
		code: DeliveryChannels.GOKADA,
		label: 'Gokada',
		shortLabel: 'GK',
		image: images.GokadaIcon,
	},
];

export const ItemTypes = {
	DRAFT: 'DRAFT',
	PUBLISHED: 'PUBLISHED',
};

export const ItemTypesLabels = {
	[ItemTypes.DRAFT]: 'Disabled',
	[ItemTypes.PUBLISHED]: 'Published',
};

export const refundTypes = {
	'Meal + Delivery': 'total',
	'Meal': 'amount',
	'Delivery Fee': 'delivery',
	'Percentage': 'percentage',
};

export const OrderStatusColors = {
	NEW: 'PENDING',
	ACCEPTED: 'PENDING',
	PREPARING: 'PENDING',
	READY: 'PENDING',
	ARRIVED: 'INFO',
	COMPLETED: 'COMPLETED',
	REJECTED: 'FAILED',
	CANCELLED: 'FAILED',
	DELIVERY: 'INFO',
	PICKUP: 'PENDING',
	UNCLAIMED: 'FAILED',
	RIDER_PENDING: 'PENDING',
	RIDER_UNAVAILABLE: 'PENDING',
	PAYMENT: 'PENDING',
};

export const OriginColors = {
	GLOVO: 'PENDING',
	REPDASH: 'FAILED',
	CHOWDECK: 'COMPLETED',
	GOKADA: 'COMPLETED',
};

export const OrderReportFormats = {
	STANDARD: 'STANDARD',
	FINANCE: 'FINANCE',
};
